import React, { useState } from 'react';
import { useResponsive } from '../hooks/useResponsive';
import { User, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_API_URL;

const Login = ({ onLogin }) => {
    const { isMobile } = useResponsive();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await fetch(`${API}/api/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: username, password })
            });
            const data = await response.json();

            if (response.ok && data.role) {
                onLogin(data);

                if (data.role === 'admin') {
                    navigate('/admin', { replace: true });
                } else if (data.role === 'teamLead') {
                    navigate('/team-lead', { replace: true });
                } else if (data.role === 'recruiter') {
                    navigate('/recruiter', { replace: true });
                } else {
                    navigate('/', { replace: true });
                }
            } else {
                setError(data.error || 'Invalid credentials');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError('Server connection failed. Ensure backend is running on port correctly.');
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: '#f4f6f8',
            fontFamily: 'Inter, system-ui, sans-serif',
            padding: isMobile ? '16px' : '0',
            boxSizing: 'border-box'
        }}>
            <form
                onSubmit={handleLoginSubmit}
                style={{
                    background: '#fff',
                    padding: isMobile ? '32px 24px' : '48px 40px',
                    borderRadius: '12px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                    width: '100%',
                    maxWidth: '420px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '24px',
                    boxSizing: 'border-box'
                }}
            >
                <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <img
                        src="/assets/logo.png"
                        alt="Company Logo"
                        style={{ width: '150px', height: '45px', objectFit: 'contain' }}
                    />
                    <h2 style={{ margin: 0, color: '#1f2937', fontSize: '18px', fontWeight: '600' }}>Recruiter360 Portal</h2>
                </div>

                {error && <div style={{ background: '#fee2e2', color: '#b91c1c', padding: '10px', borderRadius: '6px', fontSize: '14px', textAlign: 'center' }}>{error}</div>}

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>Email / Username</label>
                    <div style={{ position: 'relative' }}>
                        <User size={18} color="#6b7280" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)' }} />
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="e.g. tl1@recruiter360.com"
                            required
                            style={{
                                width: '100%',
                                padding: '12px 12px 12px 40px',
                                borderRadius: '8px',
                                border: '1px solid #d1d5db',
                                fontSize: '14px',
                                boxSizing: 'border-box',
                                outline: 'none'
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>Password</label>
                    <div style={{ position: 'relative' }}>
                        <Lock size={18} color="#6b7280" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)' }} />
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="●●●●●●●●"
                            required
                            style={{
                                width: '100%',
                                padding: '12px 12px 12px 40px',
                                borderRadius: '8px',
                                border: '1px solid #d1d5db',
                                fontSize: '14px',
                                boxSizing: 'border-box',
                                outline: 'none'
                            }}
                        />
                    </div>
                </div>

                <button
                    type="submit"
                    style={{
                        background: '#2563eb',
                        color: '#fff',
                        border: 'none',
                        padding: '12px',
                        borderRadius: '8px',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        marginTop: '10px'
                    }}
                >
                    Sign In
                </button>
            </form>
        </div>
    );
};

export default Login;